import { render } from "./TenseMenu.vue?vue&type=template&id=ed4ff622&scoped=true"
import script from "./TenseMenu.vue?vue&type=script&lang=js"
export * from "./TenseMenu.vue?vue&type=script&lang=js"

import "./TenseMenu.vue?vue&type=style&index=0&id=ed4ff622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4ff622"]])

export default __exports__